<template>
    <div>
        <Documentos idSeccion="6"/>
    </div>
</template>

<script>
import Documentos from '@/components/Documentos'
import {mapState} from 'vuex'

export default {
    name: 'Minutas',
    props: {
    },
    data() {
        return {
            variable: ''
        }
    },
    created() {
        if (this.token == '') {
            this.$router.push("nosesion");
        }
    },
    components: {
        Documentos
    },
    computed: {
        ...mapState(['token'])
    },
}
</script>

<style scoped>

</style>